export var PosStatus;
(function (PosStatus) {
    PosStatus[PosStatus["Initial"] = 0] = "Initial";
    PosStatus[PosStatus["CreatingRequest"] = 1] = "CreatingRequest";
    PosStatus[PosStatus["CreateRequestSuccess"] = 2] = "CreateRequestSuccess";
    PosStatus[PosStatus["CreatingDepositRequest"] = 3] = "CreatingDepositRequest";
    PosStatus[PosStatus["CreateDespositRequestSuccess"] = 4] = "CreateDespositRequestSuccess";
    PosStatus[PosStatus["Canceling"] = 5] = "Canceling";
    PosStatus[PosStatus["CancelSuccess"] = 6] = "CancelSuccess";
    PosStatus[PosStatus["Error"] = 7] = "Error";
})(PosStatus || (PosStatus = {}));
